import { styled } from 'styled-components';

import { RichText } from 'components/Text/RichText';
import type { CmsApiFreeCodeBlockData } from 'modules/cms/api/types/blocks/CmsApiFreeCodeBlock';

import { emailSignupBlockCss } from './emailSignupBlock';

const StyledRichText = styled(RichText)`
  ${emailSignupBlockCss}
`;

type Props = {
  data: CmsApiFreeCodeBlockData;
};

export function CmsFreeCodeBlock({ data: { code } }: Props) {
  return (
    <section>
      <StyledRichText
        dangerouslySetInnerHTML={{
          __html: code,
        }}
      />
    </section>
  );
}
